import { CommonStatusEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { StatusDefinition } from '../status.model';

/**
 * Status, die Inbetriebnahme und Netzanmeldung gemeinsam haben – nur Werte, die **beide** Backend-Enums
 * kennen (`CommissioningStatus`, `GridRegistrationStatusEnum`). Prozessspezifische Werte stehen in der
 * Definition ihres Moduls.
 */
export const COMMON_REQUEST_STATUS_DEFINITIONS: readonly StatusDefinition[] = [
  { value: CommonStatusEnum.Incomplete, defaultLabel: 'Unvollständig', defaultColor: '#f0b429' },
  { value: CommonStatusEnum.FeedbackNeeded, defaultLabel: 'Rückfrage', defaultColor: '#f0b429' },
  { value: CommonStatusEnum.ReadyToApprove, defaultLabel: 'Bereit zur Genehmigung', defaultColor: '#e7ce06' },
  { value: CommonStatusEnum.Requested, defaultLabel: 'Angefragt', defaultColor: '#71dde3' },
  // In der Inbetriebnahme nur über „Status ändern“ erreichbar.
  { value: CommonStatusEnum.UnderReview, defaultLabel: 'In Prüfung', defaultColor: '#71dde3' },
  { value: CommonStatusEnum.ReviewCompleted, defaultLabel: 'Prüfung abgeschlossen', defaultColor: '#71dde3' },
  { value: CommonStatusEnum.Approved, defaultLabel: 'Freigegeben', defaultColor: '#C3E88D' },
  { value: CommonStatusEnum.Completed, defaultLabel: 'Abgeschlossen', defaultColor: '#e99aa6' },
  { value: CommonStatusEnum.Error, defaultLabel: 'Fehler', defaultColor: '#fd7e14' }
];
